import axios from "axios";
import { handleUnauthorized } from "@/utils/auth-utils";

// Função para extrair token do cookie u_token
const extractTokenFromCookie = (): string | null => {
  try {
    const cookies = document.cookie.split(";");
    const uTokenCookie = cookies.find((cookie) =>
      cookie.trim().startsWith("u_token="),
    );

    if (!uTokenCookie) {
      const backofficeTokenCookie = cookies.find((cookie) =>
        cookie.trim().startsWith("backoffice_token="),
      );

      if (!backofficeTokenCookie) {
        return null;
      }

      return backofficeTokenCookie.split("=")[1];
    }

    return uTokenCookie.split("=")[1];
  } catch (error) {
    console.error("Erro ao extrair token do cookie:", error);
    return null;
  }
};

export const apiWobaInventory = axios.create({
  baseURL: `${import.meta.env.VITE_WOBA_INVENTORY_API}/api/v1`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor for adding auth tokens and user id
apiWobaInventory.interceptors.request.use(
  (config) => {
    const token = extractTokenFromCookie();

    if (token) {
      // Add Authorization header if needed
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("API Woba Inventory - No token found in cookies");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor for handling common errors
apiWobaInventory.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("API Woba Inventory Error:", error);

    if (error.response?.status === 401) {
      handleUnauthorized();
    }

    return Promise.reject(error);
  },
);
